import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerFeConfig } from 'src/app/modules/core/interfaces/environment.interface';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import * as defaultConfig from 'src/environments/config.json';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {
	static staticConfig: CustomerFeConfig;
	protected config$: BehaviorSubject<CustomerFeConfig>;

	/**
	 * Init
	 */
	constructor(private http: HttpClient) {
		this.config$ = new BehaviorSubject(null);
	}

	// =======================================================================================================================================
	// Methods
	// =======================================================================================================================================

	/**
	 * Get default configuration
	 */
	getDefaultConfig() {
		return _.cloneDeep(defaultConfig['default']);
	}

	/**
	 * Get environment
	 */
	getEnvironment() {
		return _.cloneDeep(environment);
	}

	/**
	 * Init Merge Process
	 * Load CustomConfig from assets and merge with environments properties
	 * This Function has to finish first before angular app starts
	 * Check app.module providers to see function call
	 */
	initConfig(): Promise<CustomerFeConfig> {
		return new Promise((resolve) => {
			// set up default Config
			this.config = _.mergeWith(this.getEnvironment(), this.getDefaultConfig(), (objValue: any, srcValue: any) => {
				// Arrays are not merged but replace the existing data
				if (_.isArray(srcValue)) {
					return srcValue;
				}
			});
			ConfigService.staticConfig = this.config;

			// load custom config and merge into default
			this.loadConfig(this.CUSTOM_CONFIG ? this.CUSTOM_CONFIG : 'environments/config.json').subscribe(
				(loadedConfig: CustomerFeConfig) => {
					// to avoid deep merge of Language Object
					// use only Language from loaded Config if passed
					if (loadedConfig && loadedConfig.languages !== undefined) {
						this.config.languages = loadedConfig.languages;
					}
					// Merge handling
					_.mergeWith(this.config, loadedConfig, (objValue: any, srcValue: any) => {
						// Arrays are not merged but replace the existing data
						if (_.isArray(srcValue)) {
							return srcValue;
						}
					});
					ConfigService.staticConfig = this.config;
					resolve(this.config);
				},
				(error1) => {
					resolve();
				}
			);
		});
	}

	// =======================================================================================================================================
	// Private Methods
	// =======================================================================================================================================

	/**
	 * Load Config from given String = by Default its from assets Folder
	 *
	 * @param url
	 */
	private loadConfig(url: string): Observable<any> {
		return this.http.get(url);
	}

	// =======================================================================================================================================
	// Getter & Setter
	// =======================================================================================================================================

	/**
	 * Get readonly CUSTOM_CONFIG
	 */
	public get CUSTOM_CONFIG() {
		return 'assets/config/config.json';
	}

	/**
	 * Get Config
	 */
	public get config(): CustomerFeConfig {
		return this.config$.getValue();
	}

	/**
	 * Get static Config
	 */
	static get config(): CustomerFeConfig {
		return this.staticConfig;
	}

	/**
	 * Getter for Observable of Config
	 *
	 * @returns
	 */
	public get configObservable(): Observable<CustomerFeConfig> {
		return this.config$.asObservable();
	}

	/**
	 * Setter for Config
	 */
	public set config(newConfig: CustomerFeConfig) {
		this.config$.next(newConfig);
	}
}
